import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    alert: {
      borderRadius: 0,
      backgroundColor: '#ebebeb',
      borderBottom: '1px solid #e0e0e0',
      fontSize: '0.775rem',
      fontWeight: 500
    },
    action: {
      marginLeft: theme.spacing(2)
    }
  });
